    import React, { useEffect, useState } from "react";
    import apiClient from "../utils/apiClient";
    import SessionHandler from "../components/SessionHandler";
    import "./CFLeaveApproval.css";

    const CFLeaveApproval = () => {
      const [requests, setRequests] = useState([]);
      const [filtered, setFiltered] = useState([]);

      // 🔹 Filters
      const [statusFilter, setStatusFilter] = useState("");
      const [employeeFilter, setEmployeeFilter] = useState("");

      const [loading, setLoading] = useState(false);

      // 🔹 Modal state
      const [showConfirm, setShowConfirm] = useState(false);
      const [showResult, setShowResult] = useState(false);
      const [selectedRequest, setSelectedRequest] = useState(null);
      const [actionType, setActionType] = useState("");
      const [resultMessage, setResultMessage] = useState("");
      const [resultType, setResultType] = useState("success");

      useEffect(() => {
        fetchRequests();
      }, []);

      /* ================= APPLY FILTERS ================= */
      useEffect(() => {
        let data = [...requests];

        if (statusFilter) {
          data = data.filter(
            (r) => r.status.toLowerCase() === statusFilter.toLowerCase()
          );
        }

        if (employeeFilter) {
          data = data.filter((r) =>
            r.employee_name
              ?.toLowerCase()
              .includes(employeeFilter.toLowerCase())
          );
        }

        setFiltered(data);
      }, [statusFilter, employeeFilter, requests]);

      const fetchRequests = async () => {
        try {
          setLoading(true);
          const data = await apiClient(
            "/cfleaves/approval/"
          );
          if (!data) return;

          setRequests(data);
          setFiltered(data);
        } catch (err) {
          console.error(err);
        } finally {
          setLoading(false);
        }
      };

      /* ================= OPEN CONFIRM MODAL ================= */
      const openConfirmModal = (req, action) => {
        setSelectedRequest(req);
        setActionType(action);
        setShowConfirm(true);
      };

      /* ================= CONFIRM ACTION ================= */
      const confirmAction = async () => {
        try {
          await apiClient(
            `/cfleaves/approval/${selectedRequest.id}/`,
            {
              method: "PATCH",
              body: JSON.stringify({ status: actionType }),
            }
          );

          setResultType("success");
          setResultMessage(
            `Carry Forward Leave ${actionType.toLowerCase()} successfully`
          );
          fetchRequests();
        } catch (err) {
          setResultType("error");
          setResultMessage("Failed to update request");
        } finally {
          setShowConfirm(false);
          setShowResult(true);
        }
      };

      /* ================= UNIQUE EMPLOYEE LIST ================= */
      const employeeOptions = [
        ...new Set(requests.map((r) => r.employee_name).filter(Boolean)),
      ];

      return (
        <div className="cfl-approval-container">
          <h2>Carry Forward Leave Approvals</h2>

          {/* ================= FILTERS ================= */}
          <div className="cf-filter cf-filter-center">
            <select
              value={employeeFilter}
              onChange={(e) => setEmployeeFilter(e.target.value)}
            >
              <option value="">All Employees</option>
              {employeeOptions.map((name, i) => (
                <option key={i} value={name}>
                  {name}
                </option>
              ))}
            </select>

            <select
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
            >
              <option value="">All Status</option>
              <option value="Pending">Pending</option>
              <option value="Approved">Approved</option>
              <option value="Rejected">Rejected</option>
            </select>
          </div>

          {/* ================= TABLE ================= */}
          <table className="cfl-approval-table">
            <thead>
              <tr>
                <th>Employee</th>
                <th>From</th>
                <th>To</th>
                <th>Days</th>
                <th>Status</th>
                <th>Reason</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {filtered.map((r) => (
                <tr key={r.id}>
                  <td>{r.employee_name}</td>
                  <td>{r.start_date}</td>
                  <td>{r.end_date}</td>
                  <td>{r.days_count}</td>
                  <td className={`status ${r.status.toLowerCase()}`}>
                    {r.status}
                  </td>
                  <td>{r.reason || "-"}</td>
                  <td>
                    {r.status === "Pending" ? (
                      <>
                        <button
                          className="btn-approve"
                          onClick={() => openConfirmModal(r, "Approved")}
                        >
                          Approve
                        </button>
                        <button
                          className="btn-reject"
                          onClick={() => openConfirmModal(r, "Rejected")}
                        >
                          Reject
                        </button>
                      </>
                    ) : (
                      "—"
                    )}
                  </td>
                </tr>
              ))}

              {!loading && filtered.length === 0 && (
                <tr>
                  <td colSpan="7" style={{ textAlign: "center" }}>
                    No Carry Forward requests
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          {/* ================= CONFIRM MODAL ================= */}
          {showConfirm && (
            <div className="modal-overlay">
              <div className="modal-box">
                <h3>Confirm Action</h3>
                <p>
                  Are you sure you want to{" "}
                  <b>{actionType.toLowerCase()}</b> this request?
                </p>
                <div className="modal-actions">
                  <button className="btn-confirm" onClick={confirmAction}>
                    Yes
                  </button>
                  <button
                    className="btn-cancel"
                    onClick={() => setShowConfirm(false)}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* ================= RESULT MODAL ================= */}
          {showResult && (
            <div className="modal-overlay">
              <div className={`modal-box ${resultType}`}>
                <h3>{resultType === "success" ? "Success" : "Error"}</h3>
                <p>{resultMessage}</p>
                <button onClick={() => setShowResult(false)}>OK</button>
              </div>
            </div>
          )}

          <SessionHandler />
        </div>
      );
    };

    export default CFLeaveApproval;
